import { TransferFeesObj, CurrencyExchangeDetails } from 'models/exchange-transfer-calculate'
import { CalculatorDataObj, ChosenCountry } from 'models/calculator-foreign'

export const defaultutCurrencyExchangeDetails: CurrencyExchangeDetails = {
  baseAmount: '100',
  baseCurrency: 'EUR',
  counterAmount: '422,59',
  direction: 'forward',
  counterCurrency: 'PLN',
}

export const defaultutExchangeCalculation: CalculatorDataObj = {
  sold_amount: '0',
  sold_currency: 'EUR',
  average_rate: '0',
  exchange_amount: '0',
  transfer_type_fee: '0',
  bought_amount: '0',
  bought_currency: 'PLN',
}

export const defaultutChosenCountry: ChosenCountry = {
  chosenCountryCode: 'PL',
  chosenCountryName: 'Polska',
}

export const defaultutTranserTypeData: TransferFeesObj[] = [
  {
    transfer_type: 'SEPA',
    currency: 'EUR',
    fee: '0.00 PLN',
    duration: {
      value: 1,
      unit: 'days',
    },
    fee_original: '0.00 PLN',
  },
  {
    transfer_type: 'TODAY',
    currency: 'EUR',
    fee: '20.00 PLN',
    duration: {
      value: 1,
      unit: 'days',
    },
    fee_original: '20.00 PLN',
  },
  {
    transfer_type: 'SEPA_INSTANT',
    currency: 'EUR',
    fee: '30.00 PLN',
    duration: {
      value: 1,
      unit: 'minutes',
    },
    fee_original: '30.00 PLN',
  },
]
